function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Tab from './Tab';
import { TabsConsumer } from './TabsContext';
import ArrowKeyListener from '../utils/ArrowKeyListener';
var propTypes = {
  children: PropTypes.node,
  className: PropTypes.string,
  theme: PropTypes.oneOf(['dark', 'light']),

  /** Size (height) of the tab (small: 32px, medium: 40px, large: 48px) */
  size: PropTypes.oneOf(['small', 'medium', 'large'])
};
var defaultProps = {
  theme: 'light',
  size: 'small'
};

var TabBar = /*#__PURE__*/function (_Component) {
  _inherits(TabBar, _Component);

  var _super = _createSuper(TabBar);

  function TabBar(props) {
    var _this;

    _classCallCheck(this, TabBar);

    _this = _super.call(this, props);

    _defineProperty(_assertThisInitialized(_this), "buildTab", function (activeIndex, tabIdArray, setActive) {
      var _this$props = _this.props,
          children = _this$props.children,
          size = _this$props.size;
      return React.Children.map(children, function (child, index) {
        var key = "tab-".concat(index);
        var onClick = child.props.onClick;

        var tabClicked = function tabClicked(value) {
          setActive(index);
          onClick && onClick(value);
        };

        return /*#__PURE__*/React.createElement(Tab, _extends({}, child.props, {
          key: key,
          id: "tab__".concat(tabIdArray[index]),
          active: index === activeIndex,
          onClick: tabClicked,
          size: size,
          ariaControls: tabIdArray[index]
        }));
      });
    });

    _defineProperty(_assertThisInitialized(_this), "nextTab", function (activeIndex, tabsLength) {
      var activeIndexPos = activeIndex + 1;

      if (activeIndexPos < tabsLength) {
        return activeIndex + 1;
      } else {
        return 0;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "prevTab", function (activeIndex, tabsLength) {
      if (activeIndex === 0) {
        return tabsLength - 1;
      } else {
        return activeIndex - 1;
      }
    });

    return _this;
  }

  _createClass(TabBar, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(TabsConsumer, null, function (_ref) {
        var activeIndex = _ref.activeIndex,
            tabIdArray = _ref.tabIdArray,
            setActive = _ref.setActive;
        return /*#__PURE__*/React.createElement("div", {
          role: "tablist",
          className: "tabs__list"
        }, /*#__PURE__*/React.createElement(ArrowKeyListener, {
          onRight: function onRight() {
            setActive(_this2.nextTab(activeIndex, tabIdArray.length));
          },
          onLeft: function onLeft() {
            return setActive(_this2.prevTab(activeIndex, tabIdArray.length));
          }
        }, _this2.buildTab(activeIndex, tabIdArray, setActive)));
      });
    }
  }]);

  return TabBar;
}(Component);

TabBar.propTypes = propTypes;
TabBar.defaultProps = defaultProps;
TabBar.__docgenInfo = {
  "description": "",
  "methods": [{
    "name": "buildTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeIndex",
      "type": null
    }, {
      "name": "tabIdArray",
      "type": null
    }, {
      "name": "setActive",
      "type": null
    }],
    "returns": null
  }, {
    "name": "nextTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeIndex",
      "type": null
    }, {
      "name": "tabsLength",
      "type": null
    }],
    "returns": null
  }, {
    "name": "prevTab",
    "docblock": null,
    "modifiers": [],
    "params": [{
      "name": "activeIndex",
      "type": null
    }, {
      "name": "tabsLength",
      "type": null
    }],
    "returns": null
  }],
  "displayName": "TabBar",
  "props": {
    "theme": {
      "defaultValue": {
        "value": "'light'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'dark'",
          "computed": false
        }, {
          "value": "'light'",
          "computed": false
        }]
      },
      "required": false,
      "description": ""
    },
    "size": {
      "defaultValue": {
        "value": "'small'",
        "computed": false
      },
      "type": {
        "name": "enum",
        "value": [{
          "value": "'small'",
          "computed": false
        }, {
          "value": "'medium'",
          "computed": false
        }, {
          "value": "'large'",
          "computed": false
        }]
      },
      "required": false,
      "description": "Size (height) of the tab (small: 32px, medium: 40px, large: 48px)"
    },
    "children": {
      "type": {
        "name": "node"
      },
      "required": false,
      "description": ""
    },
    "className": {
      "type": {
        "name": "string"
      },
      "required": false,
      "description": ""
    }
  }
};
export default TabBar;